// extracted by mini-css-extract-plugin
module.exports = {"statBadge":"StatBadge_statBadge__Q0wic","statBadgeItem":"StatBadge_statBadgeItem__FHw_P"};